import React from 'react'
import { FastField, Field } from 'formik'

import { Place } from '../../types/utils'
import placeService from '../../services/placeService'

import { FilterData } from './UserFilterDrawer'
import FormikAsyncSelect from '../FormikAsyncSelect'
import FormikMultipleCheckbox from '../FormikMultipleCheckbox'

type UserFilterFormProps = {
  isSubmitting: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  values: FilterData
}

const ROLES = ['Super Admin', 'Admin', 'Manager', 'Operator'].map((item) => ({
  value: item.replace(/ /g, '_').toLocaleUpperCase(),
  label: item,
}))

const UserFiltersForm: React.FC<UserFilterFormProps> = ({ isSubmitting, setFieldValue, values }) => {
  const placeOptions = async (inputValue: string) => {
    if (inputValue === '') return []
    return await placeService.getAll({ where: { name_contains: inputValue } })
  }

  return (
    <div className="divide-y divide-gray-200 px-4 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <p className="mb-2 font-semibold text-gray-700">Role</p>
        <FastField name="roles" component={FormikMultipleCheckbox} items={ROLES} />
      </fieldset>

      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <Field
          name="locations"
          component={FormikAsyncSelect}
          label="Location"
          isMulti
          loadOptions={placeOptions}
          getOptionLabel={(item: Place) => item.name}
          getOptionValue={(item: Place) => item.id}
          placeholder="Type Location Name"
        />
      </fieldset>
    </div>
  )
}

export default UserFiltersForm
